import { render, staticRenderFns } from "./DelayTempAccount.vue?vue&type=template&id=037d9f6a&scoped=true"
import script from "./DelayTempAccount.vue?vue&type=script&lang=js"
export * from "./DelayTempAccount.vue?vue&type=script&lang=js"
import style0 from "./DelayTempAccount.vue?vue&type=style&index=0&id=037d9f6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037d9f6a",
  null
  
)

export default component.exports